module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.getters.getCurrentState !== 'login' && _vm.$store.getters.getCurrentState !== '') ? _c('div', {
    staticClass: "logout-area"
  }, [_c('div', {
    staticClass: "nav navbar-default"
  }, [(!_vm.$store.getters.getFBAuthorized) ? _c('button', {
    staticClass: "btn btn-danger btn-xs pull-right",
    attrs: {
      "title": _vm.$t('Logout')
    },
    on: {
      "click": _vm.logoutUser
    }
  }, [_vm._v(_vm._s(_vm.$t('Logout')))]) : _c('button', {
    staticClass: "btn btn-danger btn-xs pull-right",
    attrs: {
      "title": _vm.$t('Logout')
    },
    on: {
      "click": _vm.socialLogout
    }
  }, [_vm._v(_vm._s(_vm.$t('Logout')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-xs pull-right",
    attrs: {
      "title": _vm.$t('Settings')
    },
    on: {
      "click": _vm.goToSettingsPage
    }
  }, [_c('i', {
    staticClass: "fa fa-cog fa-fw"
  })]), _vm._v(" "), (_vm.$store.getters.getLoginAsUser) ? _c('label', {
    class: _vm.balanceLabelClasses,
    attrs: {
      "title": _vm.$t('Wallet Balance')
    },
    on: {
      "click": _vm.goToSolidarityAccount
    }
  }, [_vm._v(" " + _vm._s(_vm.$store.getters.getBalance) + " € ")]) : _c('label', {
    class: _vm.daysLeftLabelClasses,
    attrs: {
      "title": _vm.$t('Days left from subscription')
    },
    on: {
      "click": _vm.gotToSubscription
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('{x} day ::: {x} days', {
    x: _vm.$store.getters.getPosSubscriptionEnd
  }, _vm.$store.getters.getPosSubscriptionEnd)) + " ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-xs our-twitter-link",
    attrs: {
      "title": _vm.$t('twitter'),
      "target": "_blank",
      "href": _vm.twitterUrl
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter fa-fw"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-xs our-facebook-link",
    attrs: {
      "title": _vm.$t('facebook'),
      "target": "_blank",
      "href": _vm.facebookUrl
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook fa-fw"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-xs our-linkedin-link",
    attrs: {
      "title": _vm.$t('LinkedIn'),
      "target": "_blank",
      "href": _vm.linkedInUrl
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin fa-fw"
  })])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6db130a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logout.vue
// module id = 314
// module chunks = 1